import {Injectable} from '@angular/core';
import {endOfMonth, addMonths} from 'date-fns/fp';

@Injectable()
export class NgMaterialFormService {
  getRangeFromValue(
    value: string,
    customStart?: Date,
    customEnd?: Date
  ): {start: any; end: any; dateOptionSelect: string} {
    const today = new Date();
    const start = customStart ? customStart : new Date();
    const end = customEnd ? customEnd : new Date();
    let dateOptionSelect = '';

    switch (value) {
      case 'today':
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        dateOptionSelect = 'today';
        break;
      case 'thisWeek':
        start.setDate(today.getDate() - ((today.getDay() + 6) % 7));
        end.setDate(start.getDate() + 6);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        dateOptionSelect = 'thisWeek';
        break;
      case 'thisMonth':
        start.setDate(1);
        end.setMonth(today.getMonth() + 1);
        end.setDate(0);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        dateOptionSelect = 'thisMonth';
        break;
      case 'lastMonth':
        start.setDate(1);
        start.setMonth(today.getMonth() - 1);
        end.setMonth(today.getMonth() - 1);
        end.setDate(endOfMonth(addMonths(-1, today)).getDate());
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        dateOptionSelect = 'lastMonth';
        break;
      case 'thisYear':
        start.setFullYear(today.getFullYear(), 0, 1);
        end.setFullYear(today.getFullYear(), 11, 31);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        dateOptionSelect = 'thisYear';
        break;
      case 'custom':
        dateOptionSelect = 'custom';
        break;
      default:
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        dateOptionSelect = 'today';
        break;
    }

    return {start, end, dateOptionSelect};
  }

  getDefault() {
    return this.getRangeFromValue('today');
  }
}
